<template>
  <div class="bounty-reward">
    <template v-if="type===1">
      <div class="g-font-num-mid amount">
        <span class="type-high" v-if="amountType===3">{{ $t('common.upTo') }}</span>
        <span>${{ val }}</span>
        <span class="type-low" v-if="amountType===1">+</span>
      </div>
      <div class="g-font-mid equivalent">{{ $t('common.equivalent') }} {{ coin }}</div>
    </template>
    <template v-else>
      <span class="g-font-num-mid amount">
        <span class="type-high" v-if="amountType===3">{{ $t('common.upTo') }}</span>
        <span>{{ val }}</span>
        <span class="type-low" v-if="amountType===1">+</span>
      </span>
      <span class="g-font-mid amount-token">{{ coin }}</span>
    </template>
  </div>
</template>

<script>

export default {
  name: 'BountyReward',
  props: {
    amountType: {
      type: Number,
      require: true,
    },
    type: {
      type: Number,
      require: true,
    },
    val: {
      type: [String, Number],
      require: true,
    },
    coin: {
      type: String,
      require: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .bounty-reward {
    text-align: right;
  }

  .amount {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
  }

  .amount-token {
    margin-left: 6px;
    line-height: 20px;
    color: var(--color-des);
    font-size: 12px;
  }

  .equivalent {
    margin-top: 6px;
    font-size: 12px;
    line-height: 16px;
    color: var(--color-des);
  }

  .type-high {
    margin-right: 5px;
    font-size: 16px;
  }

  .type-low {
    margin-left: 4px;
    font-size: 18px;
    line-height: 18px;
    vertical-align: top;
  }
</style>
